import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'

export type Usuario = z.infer<typeof zod.UsuarioSchema>
export type Filtros = z.infer<typeof zod.FiltroSchema>

export type UsuarioWithNome = Omit<Usuario, 'password'> & { nome: string }

export const CriarUsuarioSchema = z
    .object({
        email: z.string().trim().email('Email inválido'),
        password: z.string().min(6, 'A senha deve ter no mínimo 6 caracteres'),
        confirme: z.string().min(1, 'Confirme a senha'),
        categoriaId: z.coerce.number().int().min(1, 'Categoria é obrigatória'),
        clienteId: z.coerce.number().int().positive().optional().nullable(),
    })
    .refine(data => data.password === data.confirme, {
        message: 'As senhas não conferem',
        path: ['confirme'],
    })
    .transform(({ confirme: _c, ...data }) => data)

export const EditarUsuarioSchema = z
    .object({
        email: z.string().trim().email('Email inválido'),
        categoriaId: z.coerce.number().int().min(1, 'Categoria é obrigatória'),
        clienteId: z.coerce.number().int().positive().optional().nullable(),
        password: z
            .string()
            .min(6, 'Mínimo 6 caracteres')
            .or(z.literal(''))
            .optional(),
        confirme: z.string().optional(),
    })
    .refine(data => !data.password || data.password === data.confirme, {
        message: 'As senhas não conferem',
        path: ['confirme'],
    })
    .transform(({ confirme: _c, password, ...data }) => ({
        ...data,
        ...(password ? { password } : {}),
    }))

const service = new ApiService<Usuario | UsuarioWithNome>('usuarios')
const filtros = new ApiService<Filtros>('usuarios/filtros')

export const usuarios = Object.assign(service, {
    filtros,
})
